module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar"
  }, [_c('div', {
    staticClass: "navbar-brand"
  }, [_vm._m(0), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "github"
    }
  })], 1), _vm._v(" "), _c('a', {
    staticClass: "navbar-item"
  }, [_c('b-icon', {
    attrs: {
      "pack": "fab",
      "icon": "twitter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "navbar-menu"
  }, [_c('div', {
    staticClass: "navbar-end"
  }, [_c('b-dropdown', {
    attrs: {
      "position": "is-bottom-left",
      "aria-role": "menu"
    },
    model: {
      value: (_vm.navigation),
      callback: function($$v) {
        _vm.navigation = $$v
      },
      expression: "navigation"
    }
  }, [_c('a', {
    staticClass: "navbar-item",
    attrs: {
      "slot": "trigger",
      "role": "button"
    },
    slot: "trigger"
  }, [_c('span', [_vm._v("Menu")]), _vm._v(" "), _c('b-icon', {
    attrs: {
      "icon": "menu-down"
    }
  })], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "custom": "",
      "aria-role": "menuitem"
    }
  }, [_vm._v("\n                        Logged as "), _c('b', [_vm._v("Rafael Beraldo")])]), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider"
  }), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "has-link": "",
      "aria-role": "menuitem"
    }
  }, [_c('a', {
    attrs: {
      "href": "https://google.com",
      "target": "_blank"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "link"
    }
  }), _vm._v("\n                            Google (link)\n                        ")], 1)]), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "home",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "home"
    }
  }), _vm._v("\n                        Home\n                    ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "products",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "cart"
    }
  }), _vm._v("\n                        Products\n                    ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "blog",
      "disabled": "",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "book-open"
    }
  }), _vm._v("\n                        Blog\n                    ")], 1), _vm._v(" "), _c('hr', {
    staticClass: "dropdown-divider",
    attrs: {
      "aria-role": "menuitem"
    }
  }), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "settings"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "settings"
    }
  }), _vm._v("\n                        Settings\n                    ")], 1), _vm._v(" "), _c('b-dropdown-item', {
    attrs: {
      "value": "logout",
      "aria-role": "menuitem"
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "logout"
    }
  }), _vm._v("\n                        Logout\n                    ")], 1)], 1)], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-item"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/buefy-logo.png",
      "alt": "Buefy"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2a27cda"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/dropdown/examples/ExHasLinkDisabled.vue
// module id = 1068
// module chunks = 11 132